import { render, staticRenderFns } from "./group_modal.vue?vue&type=template&id=2c58a190&scoped=true&"
import script from "./group_modal.vue?vue&type=script&lang=js&"
export * from "./group_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58a190",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c58a190')) {
      api.createRecord('2c58a190', component.options)
    } else {
      api.reload('2c58a190', component.options)
    }
    module.hot.accept("./group_modal.vue?vue&type=template&id=2c58a190&scoped=true&", function () {
      api.rerender('2c58a190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/modifiers/groups/group_modal.vue"
export default component.exports